export const environment = {
  production: false,
  sw: true,
  environment: 'dev-sw',
  directusBaseUrl: 'https://cyf-directus-dev.azurewebsites.net/',
  host: 'seutuluotsi-development.azurewebsites.net',
  directusPlatformId: 7,
  firebase: {
    apiKey: 'AIzaSyDe0v4HRrbsK-XVo4TQQ7EnX3SfqF9SpA8',
    authDomain: 'seutuluotsi.firebaseapp.com',
    projectId: 'seutuluotsi',
    storageBucket: 'seutuluotsi.appspot.com',
    messagingSenderId: '785362636632',
    appId: '1:785362636632:web:c2cb42cb2696b4b9919f2d',
  },
  pushNotificationServerUrl: 'https://cyf-push-notification-development.azurewebsites.net/register',
  blogApiUrl: 'https://hoods.fi/wp-json/wp/v2/posts',
  lahellaFiUrl: 'https://www.lahella.fi/',
  appInstanceId: 'seutuluotsi',
  emailToAddress: 'info@cyf.fi',
};
